/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;

    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const desktopMedia = window.matchMedia('(min-width: 768px)');
    let previousOverflowY = '';

    const getFocusableElements = function () {
        return Array.from(navigation.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (element) {
            return element.getClientRects().length > 0;
        });
    };

    const closeMenu = function (restoreFocus) {
        navigation.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflowY = previousOverflowY;

        if (restoreFocus) {
            burger.focus();
        }
    };

    const openMenu = function () {
        previousOverflowY = document.documentElement.style.overflowY;
        navigation.classList.add('is-open');
        burger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflowY = 'hidden';

        window.requestAnimationFrame(function () {
            const firstMenuLink = navigation.querySelector('#pana-primary-navigation a[href]');
            (firstMenuLink || burger).focus();
        });
    };

    burger.addEventListener('click', function () {
        if (navigation.classList.contains('is-open')) {
            closeMenu(true);
        } else {
            openMenu();
        }
    });

    navigation.addEventListener('keydown', function (event) {
        if (!navigation.classList.contains('is-open')) return;

        if (event.key === 'Escape') {
            event.preventDefault();
            closeMenu(true);
            return;
        }

        if (event.key !== 'Tab') return;

        const focusableElements = getFocusableElements();
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (!firstElement || !lastElement) {
            event.preventDefault();
            burger.focus();
            return;
        }

        if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
        }
    });

    const handleDesktopChange = function (event) {
        if (event.matches && navigation.classList.contains('is-open')) {
            closeMenu(false);
        }
    };

    if (desktopMedia.addEventListener) {
        desktopMedia.addEventListener('change', handleDesktopChange);
    } else {
        desktopMedia.addListener(handleDesktopChange);
    }
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
